// extracted by mini-css-extract-plugin
module.exports = {"topLeaderboard":"e_0c"};